var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigateThin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6228 6.49268V25.9927M23.3777 10.4229V30.4928M3.21777 12.1626V26.7577C3.21777 29.6077 5.24277 30.7777 7.70277 29.3677L11.2278 27.3577C11.9928 26.9227 13.2678 26.8777 14.0628 27.2827L21.9378 31.2277C22.7328 31.6177 24.0078 31.5877 24.7728 31.1527L31.2678 27.4327C32.0928 26.9527 32.7828 25.7827 32.7828 24.8227V10.2276C32.7828 7.37764 30.7578 6.20764 28.2978 7.61764L24.7728 9.62764C24.0078 10.0626 22.7328 10.1076 21.9378 9.70264L14.0628 5.77264C13.2678 5.38264 11.9928 5.41264 11.2278 5.84764L4.73277 9.56764C3.89277 10.0476 3.21777 11.2176 3.21777 12.1626Z",
    stroke: "url(#paint0_linear_2759_4643)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2759_4643",
    x1: 35.6272,
    y1: 28.5215,
    x2: 6.51602,
    y2: 34.5479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7030A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#D96380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF934E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateThin);
export default __webpack_public_path__ + "static/media/navigate-thin.79d96ec1b6eaee7bbb8e76f15c48c293.svg";
export { ForwardRef as ReactComponent };